import { BaseListComponent } from "../../../shared/components/base-list/base-list.component";
import { Component, ViewChild } from "@angular/core";
import { IQuestionarioUGListaModel } from "../../../models/questionario-ug-lista.model";
import { IUniversoAuditavelModel } from "../../../models/universo-auditavel.model";
import { AuthService } from "../../../services/auth.service";
import { QuestionarioUGService } from "../../../services/questionarioug.service";
import { Router } from "@angular/router";
import {
	MatDialog,
	MatDialogConfig,
	MatDialogRef,
} from "@angular/material/dialog";
import { UnidadeGestoraService } from "../../../services/unidade-gestora.service";
import { SharedService } from "../../../services/shared.service";
import { FiltroUniversoAuditavel } from "../../../models/filtro-universo-auditavel";
import { MatTableDataSource } from "@angular/material/table";
import { UniversoAuditavelService } from "../../../services/universo-auditavel.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { IPermissaoModel } from "../../../models/permissao.model";
import { EnumRecursoPerfil } from "../../../models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "../../../models/enum/acao-recurso.enum";
import { saveAs } from "file-saver";
import {
	EUniversoAuditavelSituacao,
	EUniversoAuditavelSituacaoDescricao,
} from "../../../models/enum/universo-auditavel-situacao";
import { ModalSolicitarPreenchimentoUniversoComponent } from "./modal-solicitar-preenchimento/modal-solicitar-preenchimento.component";
import { ModalSelecaoTipoUniversoComponent } from "./modal-selecao-tipo-universo/modal-selecao-tipo-universo.component";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { HttpClient } from "@angular/common/http";
import { ITipoUniversoModel } from "../../../models/tipo-universo.model";
import { TipoUniversoService } from "../../../services/tipo-universo.service";
import { IFiltroTipoUniverso } from "../../../models/filtros/filtro-tipo-universo.model";
import { IIndicadorModel } from "../../../models/indicador.model";

const normalizeString = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[()]/g, " ")
    .toLowerCase();
};

const sortingDataAccessor = (item, property) => {
	switch (property) {
		case "versao":
			return item.versao.trim().toLowerCase();
		case "dataCriacaoFormatada":
			return item.data.trim().toLowerCase();
		case "status":
			return item.status.trim().toLowerCase();
    case "nomeTipoUniversoAuditavel":
      return normalizeString(item.nomeTipoUniversoAuditavel.trim());
		case "ativo":
			return item.ativo;
		default:
      return item.nomeTipoUniversoAuditavel.trim().toLowerCase();
	}
};

@Component({
	selector: "app-aba-universo-auditavel",
	templateUrl: "./aba-univserso-auditavel.component.html",
	styleUrls: ["./aba-univserso-auditavel.component.scss"],
})
export class AbaUniversoAuditavelComponent extends BaseListComponent {
	public selectedModel: IUniversoAuditavelModel;
	public dataSource = new MatTableDataSource<IUniversoAuditavelModel>([]);
	public filtro = {} as FiltroUniversoAuditavel;
	public searchAtivo = true;
  public tipoUniversoFilter: ITipoUniversoModel[];
  public filtroTipoUniverso = {} as IFiltroTipoUniverso;
	public botaoImportarDisable = false;
	public pageEvent: any;
	public totalItens: number;
	public displayedColumns: string[] = [
		"selecao",
		"versao",
		"nomeTipoUniversoAuditavel",
		"dataCriacaoFormatada",
		"ativo",
		"status",
	];
	public semDados = true;
	public botaoImprimirDisable = false;
	public botaoExcluirDisable = false;
	public botaoVisualizarDisable = false;
	public botaoEditarDisable = false;
	public isPreencherDisabled = false;
	public botaoNovoDisable = false;
	public permissoes: IPermissaoModel;
	private currentDialogRef: MatDialogRef<any>;
	tipoUniversoId: number;
	tipoUniverso: number;

	@ViewChild("TableOnePaginator", { static: true })
	tableOnePaginator: MatPaginator;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	optionsSituacao = [
		{ id: undefined, nome: "Todos" },
		{ id: 1, nome: "Em elaboração" },
		{ id: 2, nome: "Em preenchimento" },
		{ id: 3, nome: "Revisão" },
		{ id: 4, nome: "Pendente" },
		{ id: 5, nome: "Avocado" },
		{ id: 6, nome: "Expirado" },
		{ id: 7, nome: "Finalizado" },
	];

	constructor(
		private authService: AuthService,
		private questionarioUGService: QuestionarioUGService,
		private router: Router,
		private matDialog: MatDialog,
		private universoAuditavelService: UniversoAuditavelService,
		private tipoUniversoService: TipoUniversoService,
		private sharedService: SharedService,
		private http: HttpClient
	) {
		super();
	}

	ngOnInit(): void {
		this.setarPermissoes();
    this.filtro.ativo = true;
    this.filtroTipoUniverso.ativo = true;
    this.filtroTipoUniverso.itensPorPagina = 30;
    this.filtro.unidadeGestoraId = this.sharedService.getId();
	}

  private async configurarFiltro() {
    await this.tipoUniversoService.obter(this.filtroTipoUniverso).then(res => {
      if(res.sucesso){
        this.tipoUniversoFilter = res.dados.resultado;
      }
    });
    this.filtro.pagina = this.tableOnePaginator.pageIndex + 1;
    this.filtro.itensPorPagina = this.tableOnePaginator.pageSize;
    this.filtro.colunaOrder = this.sort.active;
    this.filtro.direcao = this.sort.direction;
    this.filtro.unidadeGestoraId = this.sharedService.getId();
  }

	async ngAfterViewInit() {
		await this.configurarFiltro();
		this.buscar();
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
		this.dataSource.sortingDataAccessor = sortingDataAccessor;
	}

	private setarPermissoes(): void {
		this.permissoes = new IPermissaoModel();
		this.permissoes.consultar = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Consultar
		);
		this.permissoes.editar = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Editar
		);
		this.permissoes.excluir = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Excluir
		);
		this.permissoes.inativarReativar = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.AtivarInativar
		);
		this.permissoes.incluir = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Inserir
		);
		this.permissoes.visualizar = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Visualizar
		);
		this.permissoes.importar = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Importar
		);
		this.permissoes.imprimir = this.authService.possuiPermissao(
			EnumRecursoPerfil.QuestionarioMaturidade,
			EnumAcaoRecurso.Imprimir
		);
	}

	public editar(id: number) {
		if (!this.permissoes.editar) {
			this.exibirMensagemErro(
				"Você não possui permissão para esta ação."
			);
			return;
		}

		this.router.navigate([`/universo-auditavel-form/${id}`]);
	}

	public excluir(id: number) {
		if (!this.permissoes.excluir) {
			this.exibirMensagemErro("Você não possui permissão para Excluir.");
			return;
		}

		this.universoAuditavelService
			.excluir(id)
			.then((res) => {
				if (res.sucesso) {
					this.exibirMensagemSucesso(
						"Universo excluído com sucesso."
					);
				} else {
					this.exibirMensagemAlerta(res.mensagem.descricao);
				}
			})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem);
			})
			.finally(() => {
				this.buscar();
			});
	}

	public novo() {
		if (!this.permissoes.incluir) {
			this.exibirMensagemErro("Você não possui permissão para Incluir.");
			return;
		}
		this.sharedService.setId(this.filtro.unidadeGestoraId);
		this.router.navigate(["tipo-universo-auditavel/novo"]);
	}

	public visualizar(id: number) {
		this.router.navigate([`visualizar-universo-auditavel/${id}`]);
	}
  public selecionarTipoUniverso(element: ITipoUniversoModel){
    if(element){
      this.filtro.tipoUniversoAuditavelId = element.id;
    }else{
      this.filtro.tipoUniversoAuditavelId = null;
    }
    this.buscar();
  }
	public imprimir(id: number) {
		this.universoAuditavelService
			.DownloadArquivo(this.filtro.unidadeGestoraId, id)
			.then((res) => {
				if (
					res &&
					res.dados &&
					typeof res.dados.url === "string" &&
					res.dados.url.trim() !== ""
				) {
					this.http
						.get(res.dados.url, { responseType: "blob" })
						.subscribe((blob) => {
							const fileName = res.dados.nomeArquivo;
							saveAs(blob, fileName);
						});
				} else {
					this.router.navigate([`imprimir-universo-auditavel/${this.selectedModel.id}`]);
				}
			});
	}

	selecionarOpcao(option: any) {
		this.filtro.status = option.nome === "Todos" ? undefined : option.nome;
		this.buscar();
	}

	isChecked(option: any): boolean {
		return option.nome === "Todos"
			? this.filtro?.status === undefined
			: this.filtro?.status === option.nome;
	}

	handleCheckboxChange(event: MatCheckboxChange, element: any): void {

    event.source._inputElement.nativeElement.click();
    this.selectedModel = event.checked ? element : null;

		if ( !!element.arquivoId  && event.checked) {
			this.botaoEditarDisable = true;
			this.botaoVisualizarDisable = true;
			this.botaoNovoDisable = true;
			this.isPreencherDisabled = true;
		} else {
			this.botaoEditarDisable = false;
			this.botaoVisualizarDisable = false;
			this.botaoNovoDisable = false;
			this.isPreencherDisabled = false;
		}

	}

	public preencher(id: number, acao: string) {

    if(this.selectedModel.arquivoId !== null && this.selectedModel.arquivoId !== undefined){
      return;
    }else{

      const situacaoAtual = this.selectedModel.status;

      const situacoesNaoPermitidas = [
        EUniversoAuditavelSituacao[EUniversoAuditavelSituacao.Pendente],
        EUniversoAuditavelSituacao[EUniversoAuditavelSituacao.Finalizado],
      ];

      if (
        !situacoesNaoPermitidas.includes(situacaoAtual) &&
        this.selectedModel.ativo === true
      ) {
        this.router.navigate([`universo-auditavel-preechimento-form`]);
        this.sharedService.setParams(
          this.selectedModel.unidadeGestoraId,
          id,
          this.selectedModel.tipoUniversoAuditavelId,
          acao
        );
      } else {
        this.exibirMensagemAlerta(
          "Universo só pode ser preenchido se estiver com Status diferente de Finalizado ou Pendente e também que esteja ativo."
        );
      }
    }
	}

	public solicitar(id: number) {

    if(this.selectedModel.arquivoId !== null && this.selectedModel.arquivoId !== undefined){
      return;
    }else{
      const situacoesPermitidas = [
        EUniversoAuditavelSituacaoDescricao[
          EUniversoAuditavelSituacao.EmElaboracao
          ],
        EUniversoAuditavelSituacaoDescricao[
          EUniversoAuditavelSituacao.Avocado
          ],
        EUniversoAuditavelSituacaoDescricao[
          EUniversoAuditavelSituacao.Expirado
          ],
      ];
      const situacaoAtual = this.selectedModel.status;

      if (
        situacoesPermitidas.includes(situacaoAtual) &&
        this.selectedModel.ativo == true
      ) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = "modal-solicitar-preenchimento";
        dialogConfig.width = "650px";
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = {
          param1: id,
        };

        this.currentDialogRef = this.matDialog.open(
          ModalSolicitarPreenchimentoUniversoComponent,
          dialogConfig
        );
        this.currentDialogRef.afterClosed().subscribe((data) => {
          this.buscar();
        });
      } else {
        this.exibirMensagemAlerta(
          "Formulário só pode ser Solicitado se estiver no Status diferente de Pendente e Ativo"
        );
      }
    }

	}

  isDesabilitaTipoImportacao(): boolean {
    return this.selectedModel.tipoDocumentoId !== 13;
  }
	public avocar(id: number) {

    if(this.selectedModel.arquivoId !== null && this.selectedModel.arquivoId !== undefined){
      return;
    }else{
      const situacao = EUniversoAuditavelSituacao.Pendente;
      if (
        this.selectedModel.status ===
        EUniversoAuditavelSituacaoDescricao[situacao] &&
        this.selectedModel.ativo == true
      ) {
        this.universoAuditavelService
          .Avocar(id)
          .then((res) => {
            if (res.sucesso) {
              this.exibirMensagemSucesso(
                "Universo Auditável avocado com sucesso."
              );
            } else {
              this.exibirMensagemAlerta(res.mensagem.descricao);
            }
          })
          .catch((err) => {
            this.exibirMensagemErro(err.mensagem);
          })
          .finally(() => {
            this.buscar();
          });
      } else {
        this.exibirMensagemAlerta(
          "Formulário só pode ser avocado se estiver no status Pendente e Ativo"
        );
      }
    }
	}

	public avaliar(id: number) {}

	public buscar() {
		this.selectedModel = null;
		this.universoAuditavelService
			.obter(this.filtro)
			.then((res) => {
				this.totalItens = res.dados.totalItens;
				// @ts-ignore
				this.dataSource =
					new MatTableDataSource<IUniversoAuditavelModel>(
						res.dados.resultado
					);
				this.paginator = this.tableOnePaginator;
				this.dataSource.sort = this.sort;
				this.dataSource.sortingDataAccessor = sortingDataAccessor;
				this.dataSource._updateChangeSubscription();
				this.semDados = this.dataSource.filteredData.length === 0;
				this.configurarFiltro();
			})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem);
			});
	}



	public importarArquivo() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component";
		dialogConfig.width = "650px";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			router: "importar-arquivo-universo-auditavel",
			unidadeGestora: this.filtro.unidadeGestoraId,
		};

		const modal = this.matDialog.open(
			ModalSelecaoTipoUniversoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
				this.filtro.pesquisa = data.nome;
				this.tipoUniversoId = data.id;
				this.tipoUniverso = data.tipo;
			}
		});
	}

	pageChanged(e) {
		this.filtro.pagina = e.pageIndex + 1;
		e.pageIndex = this.filtro.pagina;
		this.filtro.itensPorPagina = e.pageSize;
		this.buscar();
	}

	public selecionar(item: any) {
		this.selectedModel =
			!this.selectedModel || this.selectedModel.id !== item.id
				? item
				: null;
	}

	public isButtonDisabled(): boolean {
		// Verifica se existe um modelo selecionado
		if (!this.selectedModel) {
			return true;
		}

		// Verifica as condições adicionais
		return (
			!this.selectedModel.ativo ||
			!(
				this.selectedModel.status === "Em Elaboração" ||
				this.selectedModel.status === "Em Elaboração"||
				this.selectedModel.status ==="Em Elaboração" ||
				this.selectedModel.status === "Expirado" ||
				this.selectedModel.status === "Em preenchimento"
			)
		);
	}

	public isButtonDisabledRevisao(): boolean {
		// Verifica se existe um modelo selecionado
		if (!this.selectedModel) {
			return true;
		}

		// Verifica as condições adicionais
		return (
			!this.selectedModel.ativo ||
			this.selectedModel.status === "Em revisão"
		);
	}

	public isButtonPreechimentoDisabled(): boolean {
		// Verifica se existe um modelo selecionado
		if (!this.selectedModel) {
			return true;
		}

		// Verifica as condições adicionais
		return (
			!this.selectedModel.ativo ||
			!(this.selectedModel.status === "Em revisão")
		);
	}

	sortData(sort) {
		this.filtro.colunaOrder = sort.active;
		this.filtro.direcao = sort.direction;

		this.buscar();
	}

	isSelect() {
		if (this.selectedModel !== null) {
			return !this.selectedModel?.ativo;
		}
	}

	public isButtonDisabledEditar(): boolean {
		return true;
	}
}
